import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'calendar-event-search-result.calendar-label',
		defaultMessage: 'Calendar',
		description: 'Calendar event subtype label',
	},
	meetingLink: {
		id: 'calendar-event-search-result.meeting-link',
		defaultMessage: 'Meeting link',
		description: 'Calendar event meeting link label',
	},
	joinMeetingLink: {
		id: 'calendar-event-search-result.join-meeting-link',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting link',
	},
	meetingLinkIcon: {
		id: 'calendar-event-search-result.meeting-link-icon',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting icon',
	},
	recurringEventIcon: {
		id: 'calendar-event-search-result.recurring-event-icon',
		defaultMessage: 'Recurring event',
		description: 'Calendar event recurring event icon',
	},
	recurringMetadataLabel: {
		id: 'calendar-event-search-result.recurring-event-label',
		defaultMessage: 'Recurring',
		description: 'Indicates whether the calendar event has recurring events',
	},
	upcomingEventsButton: {
		id: 'calendar-event-search-result.upcoming-events-button',
		defaultMessage: 'Upcoming events',
		description: 'Label for the call to action to display the upcoming events',
	},
	pastEventsButton: {
		id: 'calendar-event-search-result.past-events-button',
		defaultMessage: 'Past events',
		description: 'Label for the call to action to display the past events',
	},
	created: {
		id: 'calendar-event-search-result.created.placeholder',
		defaultMessage: '{person} created',
		description: 'Calendar event created by label',
	},
	externalPerson: {
		id: 'calendar-event-search-result.external-person',
		defaultMessage: 'External person',
		description: 'Calendar event external person label in case name cannot be fetched',
	},
});
